// What's in Box - Variant Data Handler
window.WhatsInBoxData = (function() {
  'use strict';

  // Initialize the variant data for the current product
  function init(productData) {
    if (!productData || !productData.variants) {
      console.warn('WhatsInBoxData: No product data provided');
      return;
    }

    // Store variant data globally for access by the section
    window.productVariants = productData.variants.map(variant => ({
      id: variant.id,
      title: variant.title,
      delivery_items: parseVariantDeliveryItems(variant)
    }));

    // Listen for variant changes and update the display
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        updateWhatsInBoxDisplay(event.detail.variant.id);
      }
    });
  }

  // Parse the metafield data for a variant with delivery items
  function parseVariantDeliveryItems(variant) {
    try {
      // Check if the variant has delivery_items data (already the .value)
      if (variant.metafields &&
          variant.metafields.custom &&
          variant.metafields.custom.delivery_items) {

        const itemsData = variant.metafields.custom.delivery_items;

        // The data should already be the array of metaobjects (from .value)
        if (Array.isArray(itemsData)) {
          return itemsData.filter(item => item != null);
        }
      }

      return [];
    } catch (error) {
      console.warn('WhatsInBoxData: Error parsing variant data for variant', variant.id, error);
      return [];
    }
  }


  // Update the display when variant changes
  function updateWhatsInBoxDisplay(variantId) {
    const variantData = window.productVariants?.find(v => v.id == variantId);
    if (!variantData) return;

    // Dispatch custom event for the section to listen to
    document.dispatchEvent(new CustomEvent('whats-in-box:update', {
      detail: {
        variantId: variantId,
        items: variantData.delivery_items
      }
    }));
  }

  // Helper function to get delivery data for a specific variant
  function getDeliveryDataForVariant(variantId) {
    const variantData = window.productVariants?.find(v => v.id == variantId);
    return variantData ? variantData.delivery_items : [];
  }

  // Public API
  return {
    init: init,
    getDeliveryDataForVariant: getDeliveryDataForVariant
  };
})();